import React from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { HtmlTable } from '../../../CommonComponents/OPL/HtmlTable/HtmlTable';
import { Text } from '../../../CommonComponents/OPL/Text/Text';
import { TruncatedText } from '../../../CommonComponents/OPL/Text/TruncatedText';
import { InputNumberMask } from '../../../CommonComponents/OPL/Input/InputNumberMask';
import { MarketAssumptionsTotal } from './MarketAssumptionsTotal';

interface Props {
  formKey?: string;
}

export const MarketAssumptions = ({
  formKey = 'ExcessCashFlowStrategy.data.marketAssumptions',
}: Props) => {
  const assetClassWithValues = useWatch({
    name: 'ExcessCashFlowStrategy.data.marketAssumptions',
  });

  const { control } = useFormContext();

  if (!assetClassWithValues) {
    return null;
  }

  return (
    <>
      <Box css="margin: 0 -24px;">
        <HtmlTable variant="embedded" css="max-height: 265px; overflow-y: auto">
          <table>
            <thead>
              <tr>
                <th css="position: sticky; top: 0; z-index: 10">
                  <Text variant="smallCaps" textAlign="left">
                    Asset Class
                  </Text>
                </th>

                <th css="position: sticky; top: 0; z-index: 10">
                  <Text variant="smallCaps" textAlign="right">
                    Value
                  </Text>
                </th>
              </tr>
            </thead>

            <tbody>
              {assetClassWithValues.map(({ id, name, y }, index) => {
                return (
                  <tr key={id}>
                    <td>
                      <Box display="flex" alignItems="center">
                        <TruncatedText fontWeight={500} color="neutral.600">
                          {name}
                        </TruncatedText>
                      </Box>
                    </td>

                    <td>
                      <Controller
                        control={control}
                        name={`${formKey}.${index}.y`}
                        render={({ field: { onChange, ...rest } }) => (
                          <InputNumberMask
                            {...rest}
                            placeholder="0"
                            defaultValue={y * 100}
                            rightIcon="far fa-percent"
                            decimalScale={2}
                            allowNegative={false}
                            thousandSeparator={false}
                            sizeVariant="small"
                            id={`adv-market-assumptions-${index}`}
                            onChange={evt => onChange(evt)}
                            aria-label={`Enter ${name} Percentage`}
                          />
                        )}
                      />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </HtmlTable>
      </Box>
      <MarketAssumptionsTotal formKey={formKey} />
    </>
  );
};
